// removed by extract-text-webpack-plugin
module.exports = {"root":"SortByPopup__root__3jDxt","icon":"SortByPopup__icon__8q9d5","menuLabel":"SortByPopup__menuLabel__4ySva","menuContent":"SortByPopup__menuContent__1NXbv","menuItemBorder":"SortByPopup__menuItemBorder__1XNcz","menuItemBorderSelected":"SortByPopup__menuItemBorderSelected__rQLNk","menuHeading":"SortByPopup__menuHeading__UDEcH","menuItem":"SortByPopup__menuItem__3_9Qa","clearMenuItem":"SortByPopup__clearMenuItem__25h-T"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SortBy/SortByPopup.css
// module id = 2115
// module chunks = 0